import { useState, useMemo, createContext } from 'react';
import { routeFromURL } from '../utils/common';
import { isAuthenticated } from '../utils/auth';

export const AppContext = createContext('default');

// export const ApiContext = createContext('default');

export default function AppContextProvider(props) {
  const [isShow, setIsShow] = useState(true);
  const [isLogin, setIsLogin] = useState(false);

  useMemo(() => {
    if (isAuthenticated()) setIsLogin(true);
    if (
      routeFromURL() === 'register' ||
      routeFromURL() === 'signin' ||
      routeFromURL() === 'reset-password' ||
      routeFromURL() === 'register#' ||
      routeFromURL() === 'signin#' ||
      routeFromURL() === 'reset-password#'
    ) {
      setIsShow(false);
    } else {
      setIsShow(true);
    }
  }, [isLogin, isShow]);

  return (
    <AppContext.Provider value={{ isShow, setIsShow, isLogin, setIsLogin }}>
      {props.children}
    </AppContext.Provider>
  );
}
